import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IFeatureSHeader } from '@nomoh-monorepo/shared-angular-type-const';
import { PessoaMinhaContaComponent } from '@nomoh-monorepo/shared-common-ui';
import { FeatureSHeaderComponent } from '@nomoh-monorepo/shared-layout';

@Component({
  selector: 'app-minha-conta-page',
  standalone: true,
  imports: [PessoaMinhaContaComponent, FeatureSHeaderComponent],
  template: `
    <lib-feature-s-header [featureSHeader]="featureSHeader" />
    <div style="padding-top: 72px">
      <lib-pessoa-minha-conta
        [pessoaId]="$pessoaId()"
        [exibirAjudaSuporte]="true"
        [exibirMeusSistemas]="true"
      />
    </div>
  `,
})
export class MinhaContaPageComponent implements OnInit {
  private route = inject(ActivatedRoute);

  $pessoaId = signal('');

  featureSHeader: IFeatureSHeader = {
    logo: 'nomoh_logo.svg',
    homeRoute: '/',
    badgeIsVisible: true,
    anchors: null,
  };

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('pessoaId') ?? '';
    this.$pessoaId.set(id);
  }
}
